import { useParams } from "react-router-dom";
import React from 'react';
import { APPCONFIG } from '../../../app.config';
import '../../../assets/css/App.css';
import { Context } from "../../../context/context";
import { useContext } from "react";
import { DecodeFormBase64 } from "../../../helpers/tools";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from 'react-i18next';
import MainContent from "../../../components/mainContent/MainContent";
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";
import KpiDesktop from "../../../components/kpiDesktop/KpiDesktop";

export default function Item() {
    const [context] = useContext(Context);
    const params = useParams();
    const pathPagina = DecodeFormBase64(params.url);
    const pathSitioOriginal = (APPCONFIG.SITE.WEBNH) == "google" ? "https://www.google.com/" : APPCONFIG.SITE.WEBNH;
    const ruta = (APPCONFIG.SITE.WEBNH) == "google" ? "https://www.google.com/" : pathSitioOriginal + pathPagina;
    const { t } = useTranslation();
    const { isMobile } = useGetBreakpoints();

    useEffect(() => {
        window.scrollTo(0, 0);
        const iframeEle = document.querySelector('#iframe');
        const loadingEle = document.querySelector('.loadingFullPage');

        loadingEle.style.display = 'block';
        iframeEle.style.opacity = 0;

        iframeEle.addEventListener('load', function () {
            loadingEle.style.display = 'none';

            iframeEle.style.opacity = 1;
        });
    }, [ruta]);

    return (
        <>
            <MainContent
                tableMaxWidth={true}
                noBackground={true}
                renderIframe={true}
                component={
                    <div style={{ display: 'relative', width: '100%' }}>
                        <iframe
                            className={`iframe-responsivo ${isMobile ? 'mobile-height' : 'desktop-height'}`}
                            id="iframe"
                            src={ruta}
                            style={{ opacity: 0 }}
                            title={ruta}
                        />

                        <div class="loadingFullPage">
                            <div><CircularProgress disableShrink /><br />{t("cargando")}...</div>
                        </div>
                    </div>
                }
            />
            <KpiDesktop />
        </>
    );
}